import React from 'react';

const About = () => {
  return (
    <section id="about" className="py-20 bg-white">
      <div className="container mx-auto px-4 md:px-8">
        <div className="grid lg:grid-cols-2 gap-12 items-center">
          {/* Content */}
          <div>
            <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">
              Leading Solar EPC Solutions in India
            </h2>
            <p className="text-lg text-gray-700 mb-6 leading-relaxed">
              EKTA POWER & Green Energy Systems is a trusted name in solar EPC services, specializing in
              residential, commercial, and industrial solar installations across Maharashtra and beyond.
            </p>
            <p className="text-lg text-gray-700 mb-6 leading-relaxed">
              With over 500+ successful installations and 5MW+ of commissioned solar capacity, we bring expertise,
              quality, and reliability to every project. Our team of certified engineers and technicians ensures
              seamless installation, timely project completion, and exceptional after-sales support.
            </p>

            {/* Key Highlights */}
            <div className="grid grid-cols-2 gap-6 mt-8">
              <div
                className="p-6 rounded-xl"
                style={{
                  background: 'linear-gradient(135deg, rgba(44,200,75,0.08), rgba(0,188,212,0.12))',
                  border: '1px solid rgba(44,200,75,0.2)',
                  transition: 'box-shadow 0.3s',
                }}
                onMouseEnter={e => e.currentTarget.style.boxShadow = '0 0 20px rgba(44,200,75,0.2)'}
                onMouseLeave={e => e.currentTarget.style.boxShadow = 'none'}
              >
                <p
                  className="text-4xl font-bold mb-2"
                  style={{
                    background: 'linear-gradient(90deg, #2CC84B, #00BCD4)',
                    WebkitBackgroundClip: 'text',
                    WebkitTextFillColor: 'transparent',
                    backgroundClip: 'text',
                  }}
                >
                  8+
                </p>
                <p className="text-gray-700 font-medium">Years Experience</p>
              </div>
              <div
                className="p-6 rounded-xl"
                style={{
                  background: 'linear-gradient(135deg, rgba(0,188,212,0.1), rgba(63,81,181,0.08))',
                  border: '1px solid rgba(0,188,212,0.2)',
                  transition: 'box-shadow 0.3s',
                }}
                onMouseEnter={e => e.currentTarget.style.boxShadow = '0 0 20px rgba(0,188,212,0.2)'}
                onMouseLeave={e => e.currentTarget.style.boxShadow = 'none'}
              >
                <p
                  className="text-4xl font-bold mb-2"
                  style={{
                    background: 'linear-gradient(90deg, #2CC84B, #00BCD4)',
                    WebkitBackgroundClip: 'text',
                    WebkitTextFillColor: 'transparent',
                    backgroundClip: 'text',
                  }}
                >
                  500+
                </p>
                <p className="text-gray-700 font-medium">Happy Customers</p>
              </div>
              <div
                className="p-6 rounded-xl"
                style={{
                  background: 'linear-gradient(135deg, rgba(44,200,75,0.08), rgba(0,188,212,0.12))',
                  border: '1px solid rgba(44,200,75,0.2)',
                  transition: 'box-shadow 0.3s',
                }}
                onMouseEnter={e => e.currentTarget.style.boxShadow = '0 0 20px rgba(44,200,75,0.2)'}
                onMouseLeave={e => e.currentTarget.style.boxShadow = 'none'}
              >
                <p
                  className="text-4xl font-bold mb-2"
                  style={{
                    background: 'linear-gradient(90deg, #2CC84B, #00BCD4)',
                    WebkitBackgroundClip: 'text',
                    WebkitTextFillColor: 'transparent',
                    backgroundClip: 'text',
                  }}
                >
                  5MW+
                </p>
                <p className="text-gray-700 font-medium">Installed Capacity</p>
              </div>
              <div
                className="p-6 rounded-xl"
                style={{
                  background: 'linear-gradient(135deg, rgba(0,188,212,0.1), rgba(63,81,181,0.08))',
                  border: '1px solid rgba(0,188,212,0.2)',
                  transition: 'box-shadow 0.3s',
                }}
                onMouseEnter={e => e.currentTarget.style.boxShadow = '0 0 20px rgba(0,188,212,0.2)'}
                onMouseLeave={e => e.currentTarget.style.boxShadow = 'none'}
              >
                <p
                  className="text-4xl font-bold mb-2"
                  style={{
                    background: 'linear-gradient(90deg, #2CC84B, #00BCD4)',
                    WebkitBackgroundClip: 'text',
                    WebkitTextFillColor: 'transparent',
                    backgroundClip: 'text',
                  }}
                >
                  100%
                </p>
                <p className="text-gray-700 font-medium">Certified Team</p>
              </div>
            </div>

            {/* Certifications */}
            <div className="mt-8 flex flex-wrap gap-4">
              <div
                className="px-4 py-2 rounded-full text-sm font-semibold"
                style={{
                  background: 'linear-gradient(90deg, rgba(44,200,75,0.15), rgba(0,188,212,0.15))',
                  color: '#2CC84B',
                  border: '1px solid rgba(44,200,75,0.3)',
                }}
              >
                ✓ ISO Certified
              </div>
              <div
                className="px-4 py-2 rounded-full text-sm font-semibold"
                style={{
                  background: 'linear-gradient(90deg, rgba(0,188,212,0.15), rgba(63,81,181,0.15))',
                  color: '#00BCD4',
                  border: '1px solid rgba(0,188,212,0.3)',
                }}
              >
                ✓ Warranty Backed
              </div>
            </div>
          </div>

          {/* Image */}
          <div className="relative">
            <div className="rounded-2xl overflow-hidden shadow-2xl">
              <img
                src="https://images.unsplash.com/photo-1668097613572-40b7c11c8727"
                alt="Solar Installation"
                className="w-full h-full object-cover"
              />
            </div>
            {/* Floating Card */}
            <div
              className="absolute -bottom-6 -left-6 bg-white p-6 rounded-xl shadow-xl"
              style={{ borderTop: '4px solid #2CC84B' }}
            >
              <p className="text-sm text-gray-600 mb-1">Customer Satisfaction</p>
              <p
                className="text-4xl font-bold"
                style={{
                  background: 'linear-gradient(90deg, #2CC84B, #00BCD4)',
                  WebkitBackgroundClip: 'text',
                  WebkitTextFillColor: 'transparent',
                  backgroundClip: 'text',
                }}
              >
                98%
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;
